import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Utils from '../utils';
import { FTSI, ENROLLMENT, _LOCALE_, templateUrls } from './../../../base/vars.js';
import Form from './../../base/form.js';
import Spinner from './../../components/spinner.js';
import { getParameterByName, EventHandler, getServiceUrl, getJsonObject } from './../../../base/utils.js';
import { setLocalStorage, getLocalStorage } from '../../../base/session-handler';
import PhoneInput from '../../components/phone-input';

export default Backbone.View.extend({
  tagName: 'div',
  className: 'enroll-form',

  events: {
    'focusout input, select': 'handleValidation',
    'input input': 'handleValidation',
    'change select, input[type="checkbox"]': 'handleValidation',
    'submit': 'onSubmit'
  },

  initialize() {
    $('.app').append(this.el);
    this.getTemplate(templateUrls.firstTimeSignIn, this.$el);
    this.applyLocale();
  },

  getTemplate(url, el) {
    $.ajax({
      url: url,
      context: {
        onFail: {
          scrollToElement: $('body')
        }
      },
      success: (r) => {
        this.template = Handlebars.compile(r);
        this.render(el);
        Utils.initLegalDiscalimerForApp(this);
        EventHandler.send(EventHandler.lazyLoad.rebind);
      }
    });
  },

  onSubmit(e) {
    let isValid = this.model.isValid(true),
      options = {
        context: {
          onFail: {
            scrollToElement: $('body'),
            formElement: this.$('form'),
            ignoreCodes: ['4004'],
            ignoreAnalytics: true
          }
        }
      };
    Spinner.appendTo(this.$('form'));
    Form.disableFormField(this.$('.submit'));

    if (isValid) {
      this.model.save(null, options)
        .done((response) => {
          window.localStorage.removeItem(FTSI);
          // DAI-35677 - temp commented out until phone number between services work
          // const verifyByVoice = $('#voiceVerificationRadio').prop('checked'),
          const urlParams = new URLSearchParams(window.location.search),
            isPhApp = DOMPurify.sanitize(urlParams.has('platform')) && DOMPurify.sanitize(urlParams.has('adobeID')),
            platform = (isPhApp && urlParams.get('platform')) || '';
          const data = {
            // DAI-35677 - temp commented out until phone number between services work
            // type: verifyByVoice ? 'voice' : 'sms',
            isPhApp,
            platform,
            ...response.data[0]
          };
          setLocalStorage(FTSI, data);
          this.createOktaAccount(data, urlParams, isPhApp); // Delete this line when feature DAI-35747 is ready to be deployed
          /* // Uncomment this code when feature DAI-35747 is ready to be deployed
          const localVerificationMethodsPage = '/' + _LOCALE_ + templateUrls.verificationMethods;
          if (data && data.phones && data.phones[0] && data.phones[0].phoneNumber) {
            if (isPhApp){
              window.location.assign(localVerificationMethodsPage + '?' + urlParams);
            } else {
              window.location.assign(localVerificationMethodsPage);
            }
          } else {
            this.createOktaAccount(data, urlParams, isPhApp);
          }
          */
        })
        .fail((response, options) => {
          if (response && response.responseJSON && response.responseJSON.ErrorMessage){
            $('#ftsi-error-message').html(response.responseJSON.ErrorMessage);
            $('.notification-banner').remove();
          }
          Form.enableFormField(this.$('.submit'));
          Spinner.remove(this.$('form'));
          if (response.responseJSON.ErrorCode === '4004') {
            this.getTemplate(templateUrls.findAccountError, this.$('.enroll-form-container'));
            EventHandler.triggerEvent('ftsi_high-point-balance');
          } else {
            window.digitalData.error.errorInfo.errorFormMessage = Form.getErrorMessage(response); 
            EventHandler.triggerEvent('rewards-error', {
              errorMessage: Form.getErrorMessage(response),
              errorPath: (options && options.url) ? options.url : ''
            });
          }
        });
    } else {
      Utils.scrollToTop();
      Spinner.remove(this.$('form'));
      Form.enableFormField(this.$('.submit'));
    }
  },

  handleValidation(e) {
    Utils.setBindingAttribute(this.model, e);
    Utils.validateBindingAttribute(this.model, e);
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
    this.handleOrFormFields(e);
  },

  handleOrFormFields(e) {
    let $el = $(e.currentTarget),
      $orEl;
    switch ($el.attr('name')) {
    case 'email':
      $orEl = this.$('[name="phone"]');
      break;
    case 'phone':
      $orEl = this.$('[name="email"]');
      break;
    case 'zipCode':
      $orEl = this.$('[name="city"]');
      break;
    case 'city':
      $orEl = this.$('[name="zipCode"]');
      break;
    default:
      return;
    }

    Form.handleDisablingOrFields($el, $orEl);
  },

  applyLocale() {
    if (_LOCALE_) {
      this.model.set('Preferences.1.PreferValue', _LOCALE_);
    } else {
      this.model.set('Preferences.1.PreferValue', 'en-us');
    }
  },

  preFillUserData() {
    const enrollmentInfo = getLocalStorage(ENROLLMENT);
    if (enrollmentInfo) {
      if (enrollmentInfo.accountNumber) {
        const userAddressData = enrollmentInfo.addresses;

        $('#memberNumber').val(enrollmentInfo.accountNumber);
        if (enrollmentInfo.emails.length > 0) {
          $('#email').val(enrollmentInfo.emails[0].email);
        } else if (enrollmentInfo.phones.length > 0) {
          $('#phone').val(enrollmentInfo.phones[0].phoneNumber);
        }
        if (userAddressData.length > 0 && userAddressData[0].city) {
          $('#city').val(userAddressData[0].city);
        } else if (userAddressData.length > 0 && enrollmentInfo.addresses[0].zip) {
          $('#zipCode').val(userAddressData[0].zip);
        }
      }
    }
  },

  render(el) {
    // Need to render findAccount view to get base markup (progress tracker)
    // then check for url params from email link and route accordingly
    $(el).html(this.template(this.model.toJSON()));
    PhoneInput.setPhoneInput(document.querySelector("input.phone-input"), "Phone", "phone");
    this.preFillUserData();

    let token = getParameterByName('token');
    if (token) {
      Utils.setUserAttribute('resetPwToken', token);
      Utils.setUserAttribute('country', getParameterByName('country'));
      Utils.setUserAttribute('optInEmailOffers', getParameterByName('optInEmailOffers') == 'true' ? true : false);
      Utils.setUserAttribute('optInThirdPartyEmailOffers', getParameterByName('optInThirdPartyEmailOffers') == 'true' ? true : false);
      Backbone.history.loadUrl('username');
    } else {
      Utils.nextStep(0);
      Form.disableFormField(this.$('.submit'));
      Utils.bindBackboneValidation(this);
      Utils.triggerFormChecks();
    }
    this.validatePrefilledFields();
  },

  // DAI-35677 - the call to create onlineAccount as password setup is done by Okta for now
  createOktaAccount(data, urlParams, isPhApp) {
    const tallyStatusCodeMap = {
      'A': 'active',
      'INACTIVE': 'inactive',
      'I': 'suspended',
      'P': 'pending',
      'C': 'closed',
      'S': 'shell'
    };
    const phoneNumber = data.phones && data.phones.length > 0 && data.phones[0].phoneNumber ? 
      this.getValidPhone(data.phones[0].phoneNumber, 0) : '';
    const oktaEnrollRequest = {
      // challengeType and type required but not used when flow is set to ftsi-email
      challengeType: 'phone',
      type: 'sms',
      phoneNumber: phoneNumber,
      email: data.emails[0].email,
      name: data.firstName,
      nickName: data.firstName,
      userName: `${data.emails[0].email}.`,
      userMetadata: {
        membershipNumber: data.memberIdentifier,
        tallyStatus: data.accountStatusCode ? 
          tallyStatusCodeMap[data.accountStatusCode.toUpperCase()] : 'inactive',
        prefLang: _LOCALE_,
        flow: 'ftsi-email'
      }
    };
    $.ajax({
      url: getServiceUrl('onlineAccountSetup'),
      contentType: 'application/json',
      data: JSON.stringify(oktaEnrollRequest),
      type: 'POST',
      success: (res) => {
        const ftsiInfo = getLocalStorage(FTSI);
        const ftsiWithVerificationCodes = {
          ...ftsiInfo,
          ...res,
        };
        setLocalStorage(FTSI, ftsiWithVerificationCodes);
        const localEmailConfirmationPage = '/' + _LOCALE_ + templateUrls.emailConfirmation;
        if (isPhApp){
          window.location.assign(localEmailConfirmationPage + '?' + urlParams);
        } else {
          window.location.assign(localEmailConfirmationPage);
        }
      },
      error: responseErr => {
        const res = getJsonObject(JSON.stringify(responseErr));
        console.error(res);
        Spinner.remove(this.$('form'));
        if ($('#profile-error-message').length && res && res.responseJSON && res.responseJSON.ErrorMessage){
          $('#profile-error-message').html(DOMPurify.sanitize(res.responseJSON.ErrorMessage));
        }
      },
    });
  },

  getValidPhone(phoneNumber, index) {
    return PhoneInput.getPhoneNumberWithCountryCode(phoneNumber, index);
  },

  validatePrefilledFields() {
    // find all input fields that is type text and trigger validation manually that has value
    let inputs = this.$('form').find('input[type="text"]');
    $(inputs).each((i, e) => {
      if ($(e).val()) {
        this.handleValidation(e);
      }
    });
  }
});
